import { LatLng } from 'leaflet';
const Converter = {
    toLatLngs(coords, getLat, getLng, getVal) {
        const getLatLngExpr = (t, i) => new LatLng(getLat(t, i), getLng(t, i), getVal(t, i));
        return Array.isArray(coords[0])
            ? coords.map((cs, i) => cs.map((c) => getLatLngExpr(c, i)))
            : coords.map(getLatLngExpr);
    },
};
export default Converter;
